var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5879 2.65176C10.4206 1.48451 8.81866 0.76001 7.03961 0.76001C5.33161 0.76001 3.69358 1.43851 2.48584 2.64624C1.27811 3.85398 0.599609 5.49202 0.599609 7.20001C0.599609 8.908 1.27811 10.546 2.48584 11.7538C3.69358 12.9615 5.33161 13.64 7.03961 13.64C10.0423 13.64 12.5458 11.5873 13.2623 8.81001H11.5879C10.9278 10.6857 9.14066 12.03 7.03961 12.03C5.75861 12.03 4.53008 11.5211 3.62428 10.6153C2.71848 9.70954 2.20961 8.48101 2.20961 7.20001C2.20961 5.91901 2.71848 4.69049 3.62428 3.78468C4.53008 2.87888 5.75861 2.37001 7.03961 2.37001C8.37591 2.37001 9.56731 2.92546 10.4367 3.80291L7.84461 6.39501H13.4796V0.76001L11.5879 2.65176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshButton);
export default __webpack_public_path__ + "static/media/refresh_button.6f1e651eed04e3c2348c8921ff2f33e3.svg";
export { ForwardRef as ReactComponent };